import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';
import { CategoryEnum } from 'types/SavedProject';

import type { SavedProject } from 'types/SavedProject';

type TSavedDictionary = Record<string, SavedProject>;
type TGetSavedProjectIdsResponse = { data: TSavedDictionary; message: string };

const saveEntityToCollection = ({
  collectionId,
  projectSlug,
  documentId,
  status,
}: {
  collectionId: number;
  projectSlug?: string;
  documentId?: string;
  status: CategoryEnum;
}): Promise<AxiosResponse> => {
  return api.post(`/collection/${collectionId}/save/`, {
    project_slug: projectSlug,
    document_id: documentId,
    status,
  });
};

const getAllSavedRecordsForUser = (): Promise<
  AxiosResponse<TGetSavedProjectIdsResponse>
> => {
  return api.get(`/saved-projects/dict/`);
};

const getCollections = (): Promise<AxiosResponse<any>> => {
  return api.get('/collections/');
};

const createCollection = (name: string): Promise<AxiosResponse<any>> => {
  return api.post('/collections/', { name });
};

const updateCollection = (id: number, name: string): Promise<AxiosResponse<any>> => {
  return api.patch(`/collections/${id}/`, { name });
};

const deleteCollection = (id: number): Promise<AxiosResponse<any>> => {
  return api.delete(`/collections/${id}/`);
};

const getDefaultCollectionSummary = (): Promise<AxiosResponse<any>> => {
  return api.get('/default-collections/summary/');
};

const postDefaultCollectionProjects = (
  page: number,
  category: CategoryEnum,
  sort: string[] = [],
): Promise<AxiosResponse<any>> => {
  return api.post(`/default-collections/projects/?page=${page}`, { category, sort });
};

const postFilterCollectionProjects = (
  id: number | number[],
  page: number,
  body: object,
): Promise<AxiosResponse<any>> => {
  return api.post(`/collections/${id}/filter/?page=${page}`, body);
};

const getSharedPresence = (projectSlug: string): Promise<AxiosResponse<any>> => {
  return api.get(
    `/saved-projects/shared-presence/?project_slug=${encodeURIComponent(projectSlug)}`,
  );
};

export default {
  saveEntityToCollection,
  getAllSavedRecordsForUser,
  getCollections,
  createCollection,
  updateCollection,
  deleteCollection,
  getDefaultCollectionSummary,
  postDefaultCollectionProjects,
  postFilterCollectionProjects,
  getSharedPresence,
};
